export const BUTTON_TYPES = ['primary', 'secondary', 'linkstyle'] as const;
export type ButtonType = (typeof BUTTON_TYPES)[number];
